// extracted by mini-css-extract-plugin
export default {"container":"ComparatorItem_container__U4jLh","header":"ComparatorItem_header__X7A5u","content":"ComparatorItem_content__3AyPJ","no-data":"ComparatorItem_no-data__LeLTh"};